import React from "react";
import * as S from "../styles";
import * as St from "../../styles";
import { Account as AccountIcon, Support } from "../../../Icons";
import { DesktopMenuItem } from "../DesktopMenuItem";
import { ForBusinessesDrawerContent, LearnDrawerContent, ShopDrawerContent } from "../DesktopMenuDrawers";
import { mainPromo, productCards, productLinks, promoCards } from "../../productLinks";
import { forBusinessesCategories, learnCategories } from "../../links";
import { MembershipStatus } from "../../../../shared/types";
export var guestMenu = function guestMenu(_ref) {
  var e = _ref.url,
      t = _ref.label;
  return React.createElement(S.MenuLink, {
    "data-testid": "desktop-login-link",
    href: e
  }, React.createElement(AccountIcon, null), React.createElement(S.TextWrapper, null, t));
};
export var supportLink = function supportLink(_ref2) {
  var e = _ref2.url,
      t = _ref2.label;
  return React.createElement(S.MenuLink, {
    href: e,
    "aria-label": t
  }, React.createElement(Support, null));
};
export var registerButton = function registerButton(_ref3) {
  var e = _ref3.url,
      t = _ref3.label;
  return React.createElement(S.RegisterLink, {
    href: e
  }, t);
};
export var logo = function logo(_ref4) {
  var e = _ref4.src,
      t = _ref4.alt,
      _ref4$width = _ref4.width,
      n = _ref4$width === void 0 ? 120 : _ref4$width,
      _ref4$height = _ref4.height,
      a = _ref4$height === void 0 ? 24 : _ref4$height;
  return React.createElement(St.LogoLink, {
    href: "/"
  }, React.createElement("img", {
    src: e,
    alt: t,
    width: n,
    height: a
  }));
};
export var ShopMenu = function ShopMenu(_ref5) {
  var e = _ref5.active,
      t = _ref5.label,
      n = _ref5.slug,
      a = _ref5.handleClick,
      r = _ref5.handleClose,
      o = _ref5.onSubMenuOpen,
      l = _ref5.onSubMenuClose,
      s = _ref5.onMenuItemClick,
      c = _ref5.topLevelLinks,
      i = _ref5.root,
      u = _ref5.membership,
      m = _ref5.renderLinkAs;
  return React.createElement(DesktopMenuItem, {
    active: e,
    label: t,
    menuSlug: n,
    onClickHandler: a,
    handleClose: r
  }, React.createElement(ShopDrawerContent, {
    active: e,
    onSubMenuOpen: o,
    onSubMenuClose: l,
    onMenuItemClick: s,
    topLevelLinks: c,
    promoCards: promoCards(i),
    mainPromo: mainPromo(i),
    productCards: productCards(i, u),
    productLinks: productLinks(i),
    renderLinkAs: m
  }));
};
export var LearnMenu = function LearnMenu(_ref6) {
  var e = _ref6.active,
      t = _ref6.label,
      n = _ref6.slug,
      a = _ref6.handleClick,
      r = _ref6.handleClose,
      o = _ref6.root,
      l = _ref6.renderLinkAs;
  return React.createElement(DesktopMenuItem, {
    active: e,
    label: t,
    menuSlug: n,
    onClickHandler: a,
    handleClose: r
  }, React.createElement(LearnDrawerContent, {
    categories: learnCategories(o),
    active: e,
    renderLinkAs: l
  }));
};
export var BusinessMenu = function BusinessMenu(_ref7) {
  var e = _ref7.active,
      t = _ref7.label,
      n = _ref7.slug,
      a = _ref7.handleClick,
      r = _ref7.handleClose,
      o = _ref7.root,
      l = _ref7.ehsRoot,
      s = _ref7.renderLinkAs;
  return React.createElement(DesktopMenuItem, {
    active: e,
    label: t,
    menuSlug: n,
    onClickHandler: a,
    handleClose: r
  }, React.createElement(ForBusinessesDrawerContent, {
    categories: forBusinessesCategories(o, l),
    active: e,
    renderLinkAs: s
  }));
};
export var AccountMenu = function AccountMenu(_ref8) {
  var e = _ref8.accountMenuRef,
      t = _ref8.active,
      n = _ref8.openHandler,
      a = _ref8.onLogout,
      r = _ref8.account,
      o = _ref8.membership,
      l = _ref8.root,
      s = _ref8.renderLinkAs;
  var c = o && (o.creditsAvailable > 0 || o.state === MembershipStatus.Active);
  return React.createElement(S.MenuButton, {
    "data-testid": "desktop-account-menu-button",
    ref: e,
    onClick: n
  }, React.createElement(AccountIcon, null), React.createElement(S.TextWrapper, null, r.label), React.createElement(S.AccountSubMenu, {
    "data-testid": "desktop-account-menu",
    active: t,
    offsetMenu: o
  }, o ? React.createElement(S.StackedMenuLink, {
    href: function (_ref9) {
      var e = _ref9.type;
      return "".concat(l || "", "/").concat(e, "-membership");
    }(o),
    "data-testid": "desktop-membership-account-link",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "membership-account-link",
    "data-analytics-category": o.creditsAvailable > 0 ? "has-credits" : "no-credits",
    as: s || void 0
  }, r.membership.label, function (_ref10) {
    var e = _ref10.creditsAvailable,
        t = _ref10.state;
    var n = 1 === e ? "test" : "tests";
    return e ? React.createElement(S.MenuLinkSubText, null, "".concat(e, " free ").concat(n, " available")) : t === MembershipStatus.Active ? React.createElement(S.MenuLinkSubText, null, "20% sitewide savings") : React.createElement(React.Fragment, null);
  }(o), React.createElement(S.MenuLinkHR, {
    modifyPosition: !c
  })) : null, React.createElement(S.MenuLink, {
    href: r.results.url
  }, r.results.label), React.createElement(S.MenuLink, {
    href: r.settings.url
  }, r.settings.label), React.createElement(S.MenuLink, {
    href: r.logout.url,
    onClick: a,
    "data-testid": "desktop-logout-link"
  }, r.logout.label)));
};